// ── Single source of truth for app version ───────────────────────────────────
// Keep in sync with public/changelog.json — the latest entry's version field.
export const APP_VERSION  = '17.184'
export const APP_CODENAME = 'Warp 5'
export const APP_BUILD_ID = 'mw0squaa' // unique per-build id, overwritten by gen-version.cjs
export const APP_BUILT    = '2026-11-03'
